module.exports = __webpack_public_path__ + "media/img/resources/map-thumbnail-5f781c9014f80c54891c57fd2892f618.png";